import { or, Roles } from '@/js/libs/use-auth';

// The GenAI chat rollout is permission-driven: every platform-company user
// (CompanyRole ADMIN, i.e. audienzz) has it implicitly, everyone else gets it
// when an admin grants the GEN_AI permission to their company or user. Data
// stays safe regardless of the grant: conversations are user-scoped and the
// AdConsole agent tools run with the caller's own token. GenAI settings
// (agents, MCP servers, brand kits) stay with platform admins — see
// routes/genAI.tsx.
export const GEN_AI_CHAT_ROLES = or(Roles.ADMIN, Roles.GEN_AI);
